import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComProductDealerModel } from 'src/app/model/com-product-dealer.model';

@Injectable({
  providedIn: 'root'
})
export class ComProductDealerService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionProductDealer/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  
  save=(commission:ComProductDealerModel)=> {
    return this.http.post(`${this.url}/CommissionProductDealer/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComProductDealerModel[])=> {
    return this.http.post(`${this.url}/CommissionProductDealer/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComProductDealerModel)=> {
    return this.http.post(`${this.url}/CommissionProductDealer/SaveUpdate/${commission.dealerEmployeeJobId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
